import qs from 'qs';

import type { TrackingFn } from '@change-corgi/core-react/tracking';

import { openUrlWithHiddenAnchor } from '#src/app/shared/share/utils';

import { trackShareSuccess } from './track';

type Options = {
	trackingData: Record<string, string | number | boolean | undefined>;
	trackingEvents: {
		success: string;
	};
};

export function shareEmail(
	subject: string,
	body: string,
	{ trackingEvents, trackingData }: Options,
	track: TrackingFn,
): void {
	openUrlWithHiddenAnchor(`mailto:?${qs.stringify({ subject, body }, { encodeValuesOnly: true })}`, { newTab: true });
	trackShareSuccess(trackingEvents.success, trackingData, track);
}
